import { EmailSettings } from 'api/email';
import { EmailIntelligenceEnabledTo } from 'api/email';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { InfoBox } from 'components/atoms/info-box';
import { EmailDuration } from './settings';

const StyledUl = styled.ul`
  list-style: disc;
  margin-left: var(--spacing-05);
`;

const InfoTextBox = () => {
  return (
    <div>
      <FormattedMessage id="settings.email_intelligence.sync_description" />
      <StyledUl>
        <li>
          <FormattedMessage id="settings.email_intelligence.sync_feature_1" />
        </li>
        <li>
          <FormattedMessage id="settings.email_intelligence.sync_feature_2" />
        </li>
        <li>
          <FormattedMessage id="settings.email_intelligence.sync_feature_3" />
        </li>
      </StyledUl>
    </div>
  );
};

const EmailIntelligenceFeatures = [
  {
    title: 'settings.email_intelligence.enable',
    info: <InfoTextBox />,
  },
];

export const InitialPage = ({
  onToggle,
}: {
  onToggle: (settings: EmailSettings) => void;
}) => {
  return (
    <>
      {EmailIntelligenceFeatures &&
        EmailIntelligenceFeatures.map((listitem) => {
          return (
            <InfoBox
              key={`${listitem.title}`}
              title={listitem.title}
              info={listitem.info}
              // layout={index % 2 === 0 ? 'reverse' : 'row'}
              actionButton={{
                text: 'settings.email_intelligence.enable',
                onClick: () =>
                  onToggle({
                    emailIntelligenceEnabled: true,
                    ftueCompleted: true,
                    backSyncStartRange: EmailDuration.Past90Days,
                    backSyncStartDate: '',
                    emailIntelligenceEnabledTo:
                      EmailIntelligenceEnabledTo.SpecificTeamMembersOnly,
                  }),
                dataCy: 'settings.email_intelligence.enable',
              }}
            />
          );
        })}
    </>
  );
};
